import anime from 'animejs/lib/anime.es.js'

const VueAnime = {
  install (Vue, options) {
    anime.suspendWhenDocumentHidden = true
    Vue.prototype.$anime = anime
  }
}

export default VueAnime
